import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withWeatherData from '../withWeatherData';
import LocationSearch from '../locationSearch';
import './currentConditions.scss';

const CurrentConditions = (props) => {
  const { data, suggestedRegions } = props;

  const [isSearchExpanded, setSearchExpanded] = useState(false);

  const handleSearchExpanded = () => {
    setSearchExpanded(! isSearchExpanded);
  };

  const locationCSS = classNames(
    'forecast__location-search',
    {
      showSearch: isSearchExpanded,
      hideSearch: ! isSearchExpanded,
    }
  );

  const {
    i18n: {
      __,
    },
  } = wp;

  return (
    <Fragment key="weatherSearchForm">
      {!! data && (
        <Fragment key="weatherSearchExpanded">
          {
            isSearchExpanded && (
              <div className={locationCSS}>
                <LocationSearch
                  suggestedRegions={suggestedRegions}
                  isSearchExpanded={isSearchExpanded}
                  handleSearchExpanded={handleSearchExpanded}
                />
              </div>
            )
          }
          <button
            className="currentCond__location"
            onClick={handleSearchExpanded}
            type="button"
          >
            <span className="screen-reader-text">
              {__('Click to search by city or zip...', 'nbc')}
            </span>
            <span className="currentCond__search-icon" />
            <h3 className="currentCond__label">
              {
                (data.cityName && data.stateAbbr) &&
                `${data.cityName}, ${data.stateAbbr}`
              }
            </h3>
          </button>
          <div className="currentCond__wrapper">
            <div className="currentCond__top">
              <div className="currentCond__temp-icon">
                <div className="currentCond__temp">
                  <span className="currentCond__temp--current">
                    {data.temp}&deg;
                  </span>
                </div>
                <i className={
                  `currentCond__icon weather-icon--${data.iconCode}`
                }
                />
              </div>
              <div className="currentCond__conditions">{data.conditions}</div>
            </div>
            <div className="currentCond__details">
              <div className="currentCond__detail">
                <span className="currentCond__detail-label">
                  {__('Feels like', 'nbc')}
                </span>
                <span className="currentCond__detail-value">
                  {data.feelsLike}&deg;
                </span>
              </div>
              <div className="currentCond__detail">
                <span className="currentCond__detail-label">
                  {__('Humidity', 'nbc')}
                </span>
                <span className="currentCond__detail-value">
                  {data.humidity}%
                </span>
              </div>
              <div className="currentCond__detail">
                <span className="currentCond__detail-label">
                  {__('Precip', 'nbc')}
                </span>
                <span className="currentCond__detail-value">
                  {data.precip}%
                </span>
              </div>
              <div className="currentCond__detail">
                <span className="currentCond__detail-label">
                  {__('Wind', 'nbc')}
                </span>
                <span className="currentCond__detail-value">
                  {data.wind}MPH
                </span>
              </div>
            </div>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

CurrentConditions.propTypes = {
  data: PropTypes.shape({
    iconCode: PropTypes.string,
    temp: PropTypes.string,
    hiTemp: PropTypes.string,
    conditions: PropTypes.string,
    feelsLike: PropTypes.string,
    precip: PropTypes.string,
    humidity: PropTypes.string,
    wind: PropTypes.string,
    cityName: PropTypes.string,
    stateAbbr: PropTypes.string,
  }).isRequired,
  suggestedRegions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
};

const wrapWithWeatherData = withWeatherData('current');
export default wrapWithWeatherData(CurrentConditions);
